
export type GetCoursesStatus = typeof GetCoursesStatus[keyof typeof GetCoursesStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCoursesStatus = {
  completed: 'completed',
  'in-progress': 'in-progress',
} as const;
